(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/init.js'); 'use strict';

const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  baseUrl
} = svs.core.data;
const {
  log
} = svs.core;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  Cookies
} = svs.termsIntegrity.cookies;
const {
  Integrity
} = svs.termsIntegrity.integrity;
const {
  Rules
} = svs.termsIntegrity.rules;
const {
  Terms
} = svs.termsIntegrity.terms;
const {
  TermsIntegrityReduxProvider
} = svs.termsIntegrity.store;
const {
  TIR_HOME,
  TIR_TERMS,
  TIR_INTEGRITY,
  TIR_RULES,
  TIR_COOKIES
} = svs.termsIntegrity.constants.route;
svs.termsIntegrity.init = () => {
  svs.termsIntegrity.logger = new log.Logger('module:termsIntegrity');
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    className: "bg-white",
    withRouter: true
  }, React.createElement(TermsIntegrityReduxProvider, null, React.createElement(ErrorBoundary, null, React.createElement(Route, {
    component: Terms,
    exact: true,
    path: TIR_HOME
  }), React.createElement(Route, {
    component: Integrity,
    exact: true,
    path: TIR_INTEGRITY
  }), React.createElement(Route, {
    component: Terms,
    exact: true,
    path: TIR_TERMS
  }), React.createElement(Route, {
    component: Rules,
    exact: true,
    path: TIR_RULES
  }), React.createElement(Route, {
    component: Cookies,
    exact: true,
    path: TIR_COOKIES
  }))));
  ReactDOM.render(router, document.getElementsByClassName('js-react-container')[0]);
};
svs.termsIntegrity.init();
 })(window);